export enum ShareStatus {
    NotShared = "NotShared",
    Read = "Read",
    ReadWrite = "ReadWrite",
}